import React from 'react';
import { workExperience } from '../../data/mock';

const WorkSection = () => {
  return (
    <div className="window mb-6">
      <div className="window-header">
        <span>💼 Work Experience 💼</span>
      </div>
      <div className="window-body">
        {workExperience.map((job) => (
          <div key={job.id} className="mb-4">
            <div className="bg-gradient-to-r from-purple-100 to-pink-100 p-4 border-2 border-purple-400">
              <div className="flex justify-between items-start flex-wrap gap-2 mb-3">
                <div>
                  <h3 className="text-xl font-bold pixel-text" style={{ color: '#b06cff' }}>
                    {job.title}
                  </h3>
                  <p className="font-bold text-sm">{job.company}</p>
                </div>
                <span className="bg-white px-3 py-1 text-xs font-bold border-2 border-black">
                  {job.duration}
                </span>
              </div>

              <ul className="space-y-2 mb-3">
                {job.description.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-sm">
                    <span>⭐</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-wrap gap-2">
                {job.tags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="px-2 py-1 bg-purple-500 text-white text-xs font-bold border-2 border-purple-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WorkSection;
